import apiClient, { unwrap } from './client';
import { cache, CACHE_TAGS } from '../utils/cache';

export const salesApi = {
  getAll: async () => {
    const res = await apiClient.get('/sales', { params: { size: 1000, sort: 'date,desc' } });
    const page = unwrap(res);
    return page?.content ?? page ?? [];
  },

  create: async (sale) => {
    const res = await apiClient.post('/sales', sale);
    if (sale?.type === 'milk') cache.invalidateByTag(CACHE_TAGS.MILK_STOCK);
    return unwrap(res);
  },

  update: async (id, sale) => {
    const res = await apiClient.put(`/sales/${id}`, sale);
    if (sale?.type === 'milk') cache.invalidateByTag(CACHE_TAGS.MILK_STOCK);
    return unwrap(res);
  },

  remove: async (id) => {
    await apiClient.delete(`/sales/${id}`);
    // Milk sales debit the stock ledger — invalidate broadly since type isn't known here.
    cache.invalidateByTag(CACHE_TAGS.MILK_STOCK);
  },

  getHistory: async (from, to, periodType) => {
    const res = await apiClient.get('/sales/history', {
      params: { from, to, periodType }
    });
    return unwrap(res);
  },
};
